import React from 'react'
import classNames from 'classnames'

export default function PageWrapper({
    children,
}) {

    const Classes = classNames({
        "box-border w-full lg:flex h-screen pt-header": true,
    })

    return (
        <div className={Classes}>
            {children}
        </div>
    )
}
